import { StoreLite } from '@mailok/store-lite';
import { Filter, FilterConditions, Visualization } from '../../../core/models';
import { initialFilter } from '../index';
import { share } from 'rxjs/operators';

export const titleWindow = 'Adicionar Filtro';
export const titleEditWindow = 'Editar Filtro';
export const titleErrorWindow = 'Error';

export interface AddFilterState {
    title: string;
    step: number;
    headClass: string;
    filterActive: Filter;
}

const initialState = (): AddFilterState => ({
    title: titleWindow,
    step: 1,
    headClass: 'has__dialog__head',
    filterActive: initialFilter()
});

export class AddFilterStore extends StoreLite<AddFilterState> {
    title$ = this.select<string>(store => store.title);
    step$ = this.select<number>(store => store.step);
    headClass$ = this.select<string>(store => store.headClass).pipe(share());
    conditions$ = this.select<FilterConditions[]>(store => store.filterActive.conditions);
    visualizations$ = this.select<Visualization[]>(store => store.filterActive.visualizations);
    name$ = this.select<string>(store => store.filterActive.name);

    constructor() {
        super(initialState());
    }

    updateStep(step: number): void {
        this.update({ step });
    }

    addCondition(condition: FilterConditions): void {
        this.update(state => {
            const filter = { ...state.filterActive };
            filter.conditions.push(condition);
            return { ...state, filterActive: filter };
        });
    }

    removeCondition(condition: FilterConditions): void {
        this.update(state => {
            const filter = { ...state.filterActive };
            filter.conditions = filter.conditions.filter(con => con.name !== condition.name);
            return { ...state, filterActive: filter };
        });
    }

    addVisualization(visualization: Visualization): void {
        this.update(state => {
            const filter = { ...state.filterActive };
            filter.visualizations.push(visualization);
            return { ...state, filterActive: filter };
        });
    }

    removeVisualization(visualization: Visualization): void {
        this.update(state => {
            const filter = { ...state.filterActive };
            filter.visualizations = filter.visualizations.filter(con => con.name !== visualization.name);
            return { ...state, filterActive: filter };
        });
    }

    updateName(name: string): void {
        this.update(state => {
            const filter = { ...state.filterActive };
            filter.name = name;
            return { ...state, filterActive: filter };
        });
    }

    getFilter(): Filter {
        return this.selectSnapshot<Filter>(state => state.filterActive);
    }

    updateFilter(filterActive: Filter): void {
        this.update({ filterActive, title: filterActive.id ? titleEditWindow : titleWindow });
    }

    updateHeadClass(headClass: string): void {
        this.update({ headClass });
    }

    reset(): void {
        this.update(initialState());
    }
}
